import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import $ from 'jquery';
import { HelperService } from 'src/app/core/services/helper.service';
import { ModalComponent } from '../components/modal/modal-base/modal.component';
import { ModalContentOptions, ModalOptions } from '../components/modal/modal-base/modal.options';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  private modals: any[] = [];

  // API to all active modals in session
  public allNgbModalRef: NgbModalRef[];

  constructor(private helperService: HelperService, private ngbModal: NgbModal) { }

  public showWarning(message: string | string[], headertext?: string) {
    if (!headertext) {
      headertext = 'Warning';
    }

    let msg = '';
    if (typeof message !== 'string') {
      const $ul = $('<ul></ul>');
      this.helperService.buildList(message, $ul);
      msg = $ul.html();
    } else {
      msg = message;
    }

    const modalWarningOptions: ModalContentOptions = {
      isModal: false,
      isWarning: true,
      isError: false,
      closeButtonText: 'No',
      actionButtonText: 'Yes',
      headerText: headertext,
      bodyText: msg
    };
    return this.showModal(null, modalWarningOptions);
  }

  public showError(message: string | string[], headertext?: string) {
    if (!headertext) {
      headertext = 'Error';
    }

    let msg = '';
    if (typeof message !== 'string') {
      const $ul = $('<ul></ul>');
      this.helperService.buildList(message, $ul);
      msg = $ul.html();
    } else {
      msg = message;
    }

    const modalErrorOptions: ModalContentOptions = {
      isModal: false,
      isWarning: false,
      isError: true,
      closeButtonText: 'Close',
      headerText: headertext,
      bodyText: msg
    };
    return this.showModal(null, modalErrorOptions);
  }

  public showInfo(message: string | string[], headertext?: string) {
    if (!headertext) {
      headertext = 'Info';
    }

    let msg = '';
    if (typeof message !== 'string') {
      const $ul = $('<ul></ul>');
      this.helperService.buildList(message, $ul);
      msg = $ul.html();
    } else {
      msg = message;
    }

    const modalErrorOptions: ModalContentOptions = {
      isModal: false,
      isWarning: false,
      isError: false,
      isInfo : true,
      closeButtonText: 'Ok',
      headerText: headertext,
      bodyText: msg
    };
    return this.showModal(null, modalErrorOptions);
  }


  public showModal(modalOptions?: ModalOptions | null, modalContentOptions?: ModalContentOptions, modalComponent?: any) {
    if (!modalOptions) {
      modalOptions = new ModalOptions();
    }
    // modalOptions.backdrop = 'static';
    // this.rootScope.modalOpened = true; //This need to be checked - Subash
    return this.show(modalOptions, modalContentOptions, modalComponent);
  }

  private show(modalOptions?: ModalOptions, modalContentOptions?: ModalContentOptions, modalComponent?: any) {

    if (!modalComponent) {
      modalComponent = ModalComponent;
    }
    if (!modalOptions) {
      modalOptions = new ModalOptions();
    }
    if (!modalContentOptions) {
      modalContentOptions = new ModalContentOptions();
    }

    const ngbModalRef = this.ngbModal.open(modalComponent, modalOptions as NgbModalOptions);
    if (modalContentOptions) {
      ngbModalRef.componentInstance.modalContentOptions = modalContentOptions;
    }

    if (!this.allNgbModalRef) {
      this.allNgbModalRef = [];
    }

    this.allNgbModalRef.push(ngbModalRef);

    return ngbModalRef.result;
  }

  add(modal: any) {
    // add modal to array of active modals
    this.modals.push(modal);
  }

  remove(id: string) {
    // remove modal from array of active modals
    this.modals = this.modals.filter(x => x.id !== id);
  }

  open(id: string) {
    // open modal specified by id
    const modal: any = this.modals.filter(x => x.id === id)[0];
    modal.open();
  }

  close(id: string) {
    // close modal specified by id
    const modal: any = this.modals.filter(x => x.id === id)[0];
    modal.close();
  }
}

